<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div @click="showDropdowns" class="wy-header-menu-direction" v-bind:class="{'selected': isSelected}" v-if="enableFilter">
      <el-dropdown 
        class="wy-header-manu-dropdown" 
        ref="directionWidget" 
        placement="top" 
        trigger="click"
        :hide-on-click="false" 
        @visible-change="handleChangeVisible">
        <span class="el-dropdown-title wy-disable-select">
          <div class="header-title">
            Direction
          </div>
          <div class="button-container">
                <div class="el-dropdown-subtitle">
                <div class="direction-header">{{ directionHeader }}</div>
                <!-- <span class="direction-count">{{ directionCount }}</span> -->
                </div>
              <i v-bind:class="{'el-icon-caret-right':!isSelected, 'angle-up':isSelected }" ></i>
          </div>
        </span>
        
        <el-dropdown-menu id="wyPlatformPanel" ref="directionsPopup" class="wy-header-menu-panel wy-header-menu-directions-panel" slot="dropdown" :class="{'has-brand': showBrands, 'no-date-range-layout': isDateRageHidden}">
          <div class="menu-panel" >
            <div class="filtering-panel"> 
              <table class="table-content">
                <tr>
                  <td>
                    <div class="directions-title">Direction</div>
                    <div class="dropdown-directions">  
                      <div class="filter-section mutiple-select-section agent-groups">
                        <el-dropdown-item>
                          <el-select
                            v-model="dataModel.filters.directions.value"
                            ref="agentHandlingDropdown"
                            collapse-tags
                            :popper-append-to-body="true"
                            popper-class="direction-dropdown"
                          >
                            <el-option v-for="(direction) in dataModel.filters.directions.dataSource" :key="direction.key" :label="direction.label" :value="direction.key"> </el-option>
                          </el-select>
                        </el-dropdown-item>
                      </div> 
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <a @click="closePopup()" class="cancel-btn prevent-select">Cancel</a>
          <a @click="clearAll()" class="clear-btn prevent-select">Reset all</a>
          <el-button :disabled="!hasChanged" class="wy-white-button global-filters-apply" ref="globalFiltersApplyBtn" size="mini" @click="handleApply()">{{ $t('button.apply') }}</el-button> 
        </el-dropdown-menu>
      </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WyFilter from '../../../library/wy-filter';

export default {
  name: 'wy-header-menu-direction',

  data() {
    return {
      isSelected: false,
      hasChanged: false
    }
  },

  watch: {
    'dataModel.dateStart': {
      immediate: false,
      handler() {
        if(this.$refs.directionWidget) {
          this.$refs.directionWidget.triggerElmFocus = function() {};
        }        
      }
    }
  },

  computed: {
    ...mapGetters(['authUser', 'dataModel', 'moreFiltersCounter']),

    enableFilter() {
      let hasChanaged = this.$store.state.site.changed;
      
      if(hasChanaged) {
        return this.dataModel.hasFilter;
      }
      else {
        return false;
      }
    },

    selectedValue() {
      return this.dataModel.filters.directions.value;
    },

    isDateRageHidden() {
      let widget = this.$route.meta.headerMenuItems.find(el=>{
        return el.name == 'date-widget'
      })
  
      let isHidden = false;
      if((widget && widget.properties.hidden) || widget == undefined) {
        isHidden = true
      }
      return isHidden;
    },

    directionHeader() {
      let directionT = "Direction";
      let direction = this.dataModel.filters.directions.dataSource.find(el => el.key == this.selectedValue);
      if(direction) {
        directionT = direction.label;
      }
      else {
        directionT = 'All';
      }
      return directionT;
    },

    showBrands () {
      return this.authUser && this.authUser.companyList && this.authUser.companyList.length > 1;
    }
  },

  methods: {
    ...mapActions(['applyFilterValue', 'undoFilterValue']),

    showDropdowns(){
      setTimeout(() => {
        document.querySelectorAll('.el-select-dropdown__wrap').forEach(el => {
          el.style.display = "block";
        })
      }, 0);
    },  

    checkChanged() {
      this.hasChanged = this.dataModel.filters.directions.value != this.dataModel.filters.directions.previousValue;
    },

    handleChangeVisible(isOpen) {
      if(isOpen){
        // setTimeout(() => {
        //   let clickSourceEl = document.querySelector('.wy-header-menu-direction')
        //   let el = document.querySelector('.wy-header-menu-directions-panel')
        //   el.setAttribute('style', `left: ${clickSourceEl.getBoundingClientRect().left}px !important; transition-delay: 0s; position: absolute; transform-origin: center top; z-index: 2001;`);  
        // }, 0);
        let dom = document.querySelector('.component.direction-dropdown-widget');
        setTimeout(() => {
          let el = document.querySelector('.wy-header-menu-directions-panel')
          el.setAttribute('style', `left: ${dom.getBoundingClientRect().x}px !important; transition-delay: 0s; position: absolute; transform-origin: center top; z-index: 2001;`);  
        }, 0);
        this.$refs.directionWidget.show();
        this.$refs.directionWidget.popperElm.style.transitionDelay = "0s";
        this.isSelected = true;
        this.$refs.directionWidget.triggerElm.disabled = true;
      }
      else {
        this.$refs.directionWidget.triggerElm.disabled = false;
        this.$refs.directionWidget.hide();
        this.$refs.directionWidget.popperElm.style.transitionDelay = "0.1s";
        this.isSelected = false;
      }

      // fire global click overlay event to show the modal
      this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: this.handleApply, active: isOpen});
    },

    async handleApply() {
      if(await this.applyFilterValue(this.dataModel.filters.directions)) {      
        this.dataModel.appliedFiltersCounter = this.moreFiltersCounter;
        if(!WyFilter.compareValues(this.dataModel.filters.directions.value, this.dataModel.filters.directions.valueOrigin)) {
          this.dataModel.appliedFiltersCounter = this.dataModel.appliedFiltersCounter + 1;
        }
        this.$root.fireEvent({name: 'handleFilterChange', type: 'Global Filter: Channel'});
      }
      this.handleChangeVisible(false);
    },

    closePopup() {
      this.dataModel.filters.directions.value = this.dataModel.filters.directions.previousValue;
      this.handleChangeVisible(false);
    },
    clearAll() {
      this.dataModel.filters.directions.value = '';
    }
  },

  updated() {
    if(document.querySelector(".component.direction-dropdown-widget")) {
      if(!this.dataModel.hasFilter) {
        document.querySelector(".component.direction-dropdown-widget").style.display = 'none';
      }
      else {
        document.querySelector(".component.direction-dropdown-widget").style.display = 'inline-block';
      }
    }
    this.checkChanged();
  },

  mounted() {
    if(!this.dataModel.hasFilter) {
      document.querySelector(".component.direction-dropdown-widget").style.display = 'none';
    }
    else {
      document.querySelector(".component.direction-dropdown-widget").style.display = 'inline-block';
    }
    this.checkChanged();
  },
  beforeDestroy() {
    // this.handleChangeVisible(false);
  }
}
</script>

<style lang="scss">
  .wy-header-menu-direction.selected{
    .el-dropdown-subtitle{
      position: relative !important;
      bottom: 10px !important;
    }
  }
.wy-header-menu-direction{
  // padding-right: 20px;
  .el-checkbox__input.is-disabled.is-checked .angle-up {
    top: 6px !important;
  }
  .button-container{
    float: left;
    // width: 200px;
    // width: fit-content;
    height: 32px;
    position: relative;
    // bottom: 47px;
    display: flex;
    /* padding-bottom: 24px; */
    align-items: flex-end;
    width: 150px;

    i {
      position: inherit !important;
    }
  }
  .direction-header {
    width: fit-content;
    max-width: 100px;
    // width:116px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    bottom: 3px;
    height: fit-content;
  }
  .direction-count{
    position: relative;
    bottom: 6px;
    // left: 4px;
  }
  .el-dropdown-subtitle {
    display: inline-block;
    padding-right: 7px;
    width: fit-content;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    right: -24px;
    bottom: 10px;
  }

  .angle-up {
    background-image: var(--header-drop-down-arrow-up);
    background-repeat: no-repeat;
    background-color: transparent;
    border: none;
    padding: 0;
    top: 3px;
    position: relative;
    height: 31px;
    background-size: 10px;
    width: 15px;
    left: 28px;
    margin-left: auto;
    display: inline-block;
  }
  .el-dropdown-title .button-container .el-icon-caret-right,.angle-up {
    left: -8px !important;
  }
}
.wy-header-menu-directions-panel.wy-header-menu-panel.no-date-range-layout{	
  left: 300px !important;
}

.wy-header-menu-panel.wy-header-menu-directions-panel.has-brand {
  left: var( --site-top-menu-directions-panel-left-show-brand) !important;
}
.wy-header-menu-directions-panel {
  // min-width: 350px !important;
  // height: calc(100vh - 30px) !important;
  // max-height: 630px;
  width: min-content;
  border-radius: 0px;
  // width: 2099px;
  // left: 995px!important;
  margin: 64px 0px 0px 0px !important;
  // overflow-y: auto;
  // max-height: 500px;
  border-radius: 0px !important;
  // left: calc(100vw - 1181px) !important;
  // left: var(--site-top-menu-filtering-panel-left-interactions) !important;
  // left: unset !important;
  // right: 20px !important;
  .wy-header-menu-panel{
    height: 723px !important;
  }
  .el-scrollbar__wrap {
    background: #0F1A20 !important;
  }
  .vue__time-picker .dropdown .select-list {
  position: relative;
  top: 10px;
  width: 10em;
  height: 12em;
  border-radius: 5px;
  }
  .el-tag.el-tag--info {
    background: var(--top-menu-panel-filters-dropdown-tag-background-color);
    border: none;
    color: var(--nav-top-primary-color);
    // padding:5px 10px 5px 10px !important;
    padding: 1px 10px 1px 10px !important;
    font-size: 14px;
    // max-width: 800px!important;
    max-width: 49px !important;
    width: 146px;
    // height: 34px;
    height: 24px;
    top: 5px;
    position: relative;
    z-index: -1;
    margin-left: 1px;
  }
  .el-tag.el-tag--info:first-child {
    max-width: 146px !important;
    left: 5px;
  }
  // .el-tag.el-tag--info:last-child {
  //   max-width: 49px !important;
  // }
  table {
    border-spacing: 0;
  }
  .directions-title {
    font-size: 12px;
    margin-left: 30px;
    padding-top: 30px;
    font-weight: 500;
    color: #64727C;
  }
  .dropdown-directions {
    position: relative;
    left: 30px;
    width: 304px;
  }
  
  .vue__time-picker .dropdown .hint {
      padding-top: 0px;
      padding-bottom: 5px;
      line-height: 17px;
  }
  .vue__time-picker .dropdown {
    position: absolute;
    z-index: 5;
    top: calc(2.2em + 8px);
    left: 0;
    background: #020E14;
    box-shadow: 0 1px 6px rgba(0,0,0,0.15);
    width: 10em;
    height: 10em;
    font-weight: normal;
  }
  span.char.times-icon {
      display: none !important;
  }
  .vue__time-picker .controls .char {
    display: inline;
  }
  .el-select-dropdown.el-popper.is-multiple.global-filter-picker-multiple-popper {
    top: 294px !important;
  }
  .el-select-dropdown {
    border: none !important;
  }
  .divider-line {
    position: relative;
    top: -80px;
    padding: 0px;
    margin: 0px;
    border-top: thin solid #D2D8DC;
  }
  .cancel-btn{
    position: relative;
    bottom: 54px;
    left: 7px;
    font-size: 14px;
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    cursor: pointer;
  }
  .vue__time-picker .dropdown ul li {
    padding: 0em 0;
  }
  .clear-btn {
    position: relative;
    bottom: 54px;
    left: calc(100% - 260px);
    font-size: 14px;
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
  
  .el-button {
    font-size: 14px !important;
    padding: 10px;
    font-weight: 400;
    background: #020E14;
    color: rgb(255, 255, 255)!important;
  }

  .el-checkbox__inner {
    top: 2px !important;
    width: 12px !important;
    height: 12px !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--top-menu-panel-global-filter-header-text-color);
  }
  .filtering-panel {
    //height: calc(100vh - 60px);
    // max-height: 597px;
    // overflow-y: auto;
    max-height: calc(100vh - 144px);
    overflow: hidden;
    display: inline-flex;
    padding-top: 0px;
    height: 188px !important;
    // height: 382px;
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
  }
  .menu-panel {
    // padding: 0px 0 8px 0;
    // margin-right: 15px;
    // background-color: #020E14;
    //height: inherit;
    //max-height: 622px;
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    // padding-bottom: 10px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    // width: 535px;
    width: 364px;
    position: relative;
    right: 0px;
    // min-height: 300px;
    height: 368px;
    // height: 469px;
    // min-width: 1078px;
    margin-left: -1px;
    // border-top: 1px solid #C9D3DA;
    box-shadow: 0px 4px 10px rgba(74, 74, 74, 0.25);
    border-radius: 0px 0px 5px 5px;
  }
  // @media (max-width: 1854px){
  // .wy-header-menu-filtering-panel-ca.no-date-range-layout 
  //   .menu-panel {
  //     right: 396px
  //   }
  // }
  // @media (max-width: 1854px){
  // .menu-panel {
  //     left: 2px !important;
  //   }
  // }

  .wy-white-button.global-filters-apply {
    width: 84px;
    height: 30px;
    border-radius: 10px;
    border: 1px white solid;
    left: calc(100% - 242px);
    top: -54px;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    padding-top: 6px;
    font-size: 14px;
    background: #020E14;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }

  > li.el-dropdown-menu__item {
    padding-bottom: 3px;
  }


  .filter-section.sources label.el-checkbox {
    padding-top: 8px;
    padding-bottom: 2px;
    padding-left: 14px;
    width: 216px;
    display: flex;
    align-content: center;
    flex-direction: row;
  }
  .filter-section.languages label.el-checkbox {
    margin-bottom: 19px;
    width: 224px;
  }
  .languages .el-checkbox__label, .sources .el-checkbox__label {
    font-weight: 500;
    line-height: 15px;
    white-space: pre-line;
  }
  .filter-section.avg-handling-time {
    padding-bottom: 3px;
    padding-left: 35px;
    position: relative;
    .vue__time-picker input.display-time {
      color: #FFF;
      &:focus-visible{
        outline: none !important;
      }
    }
    .vue__time-picker .dropdown ul li:not([disabled]).active{
      background: #1B262B !important;
    }
    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px; 
      background-position-y: center; 
      font-size: 13px;
      color: #59333E;
      border-radius: 5px;
      width: 245px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
  }
  .filter-section.business-hours {
    label.el-checkbox {
      padding-left: 10px !important;
      padding-bottom: 1px;
      padding-top: 7px;
    }
    .business-hours-title {
      font-size: 14px;
      display: block;
      color: #F4F6F8;
      font-weight: 600 !important;
      margin-bottom: 15px;
      margin-top: 9px;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label {
      cursor: not-allowed;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      cursor: not-allowed;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner::after {
      cursor: not-allowed;
    }
  }
  .el-checkbox.is-disabled {
    cursor: not-allowed;
    .el-checkbox__input {
      pointer-events: none;
    }
    .el-checkbox__label {
      pointer-events: none;
    }
  }
  .el-input__inner{
    border: 0px;
  }
  ::placeholder {
    color: var(--nav-top-placeholder-color) !important;;
    opacity: 1; /* Firefox */
  }
  .el-select {
    display: block;
    border-radius: 10px;
    // border: 1px solid #DCDFE6;
    padding: 0px 5px 0px 0px;

    .el-select-dropdown {
      margin-top: 6px !important;
      left: 0px !important;
      min-width: 211px !important;

      .el-select-dropdown__wrap {
        max-height: 260px !important;
      }
    }
  }
  .el-date-editor--daterange {
    width: 260px !important;
  }
  .el-select-dropdown.el-popper.is-multiple {
    width: 210px;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #214586;
  }
  .el-select-dropdown.el-popper {
    width: 210px;
  }
  .el-select__tags {
    max-width: 220px !important;
    width: 19%;

    .el-select__tags-text {
      word-break: break-word;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #F6F7F8;
  }
  .wy-filter-integer {
    .el-input-number--mini {
      width: 100px;
      line-height: 26px;
    }
    table {
      color: var(--site-font-primary-color);
      td:first-child {
        padding-left: 0px;
      }
      td {
        padding-left: 15px;
      }
    }
  }
  
  .wy-filter-integerRange {
    table {
      td:first-child {
        padding-left: 0px;
      }
      td {
        padding-left: 15px;
        color: #000000;
      }
    }
    .el-input.el-input--mini::after {
      content: "min";
      position: absolute;
      left: 45px;
      font-size: 10px;
    }
    .el-input-number--mini {
      width: 100px;
      input {
        padding-left: 0px;
        text-align: right;
        padding-right: 60px;
      }
    }
  }

  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    // background-color: #020E14 !important;
    background-color: transparent !important;
    color: #F4F6F8;
  }
  .el-select .el-input.is-focus .el-input__inner {
      border-color: #C0C4CC;
      // height: 28px !important;
  }
  .el-dropdown-menu__item{
    padding: 10px 14px 0 20px;
    cursor: unset;
  }
  .el-dropdown-menu__item:nth-child(3) {
    text-align: right;
  }
  .filter-section .el-dropdown-menu__item{
    width: 100%;
    display: inline-block;
    padding: 5px 0px 0px 0px;  
    margin-bottom: 0px;
  }
  .filter-section .el-dropdown-menu__item.checkbox-item {
    width: 88%;
  }
  .filter-section  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    right: 12px;
  }
  .el-dropdown-menu__item i {
    margin-right: 0px;
  }

  span.filter-title {
    display: block;
    font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
    // font-size: var(--top-menu-panel-global-filter-header-text-font-size);
    font-size: 12px;
    color: var(--site-interaction-primary-font-color);
    margin-bottom: 2px;
    line-height: 20px !important;
  }
  .max-topics span.filter-title {
    position: relative;
    top: 17px;
    height: 10px;
  }
  .filter-title-clear-all{
    float: right;
    font-size: 14px;
    font-weight: 500;
    color: #FFF;
    margin-right: -6px;
    cursor: pointer;
    position: relative;
    top: 279px;
    width: 60px;
    min-width: 58px;
    height: fit-content;
    left: calc(100% - 1334px) !important;
  }
  .filter-title-clear{
    font-size: 14px;
    color: #214586;
    cursor: pointer;
  }

  .vue__time-picker,.vue__time-picker input.display-time {
    color: var(--site-font-primary-color);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: #020E14;
    border-radius: 5px;
    width: 90px !important;
    height: 38px;
    -webkit-box-shadow: unset !important;
    box-shadow: none !important;
    outline: none !important;
  }
  .vue__time-picker .dropdown ul li {
    background-color: #0F1A20 !important;
    &:hover{
      background: #1B262B !important;
      color: white;
    }
  }
  .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover{
    color: white !important;
  }
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar {
    width: 12px;
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar {
    width: 12px;
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar {
    width: 12px;
  }
  span.el-tag.el-tag--info.el-tag--small.el-tag--light {
    width: 101px;
  }
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #CCC; 
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }

  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }

  .vue__time-picker .dropdown ul li {
    color: #F4F6F8;
    background-color: #384c55;
  }
  .from-to-sign {
    padding: 0 15px;
    color: #FFF;
  }
  .display-top {
    color: var(--nav-top-primary-color);
    width: 80px;
    vertical-align: bottom !important;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    bottom: 9px;
    padding-right: 5px;
  }
  .display-top-topics {
    color: var(--nav-top-primary-color);
    padding-left: 5px;
    width: 80px;
    vertical-align: bottom !important;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    left: -10px;
    bottom: 9px;
  }
  input {
    color: var(--site-font-primary-color);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .el-select__input {
    // color: #FFF !important;
    // color: var(--site-font-primary-color) !important;
    color: var(--nav-top-primary-color) !important;
    width: 100% !important;
    // max-width: none !important;
    margin-left: 10px;
  }
  .el-input{
    width: 100% !important;
    overflow: hidden;
  }
  .el-select .el-input.is-focus .el-input__inner {
    // height: 70px !important;
  }
  .el-checkbox-group {
    margin-bottom: -10px;
    margin-top: 0px;

    .el-checkbox {
      display: flex;
      height: 23px;
      color: var(--top-menu-panel-global-filter-header-text-color);
      margin-bottom: 20px;
      span.el-checkbox__inner {
        border-radius: 0px;
        background-color: var(--top-menu-panel-global-filter-checkbox-button-background-color);
        color: var(--top-menu-panel-global-filter-checkbox-button-check-color);
        border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-border-color) !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
      }
      .el-checkbox__inner::after {
        border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-check-color);
        border-left: 0;
        border-top: 0;
        width: 2px !important;
        top: 0px;
        left: 4px;
      }
      span.el-checkbox__inner:hover {
        -webkit-box-shadow: unset;
        box-shadow: unset;
      }
    }
    .el-checkbox.BotOnlyEscalated {
      left: 29px;
      padding-bottom: 17px!important;
      padding-top: 12px !important;
      padding: 25px;
      width: 162px !important;
      border-radius: 5px;
      margin-bottom: 19px; 
    } 
    .el-checkbox.BotOnlyContained{
      left: 29px;
      border-radius: 5px;
      // padding-bottom: 18px!important;
      // padding-top: 12px !important;
      padding: 25px;
      width: 162px !important;
      margin-bottom: 20px;
    }
    .el-checkbox.BotToLC{
      padding-bottom: 17px !important;
    }
  }

  table.table-content {
    td {
      vertical-align: top;
      
      .mutiple-select-section .wy-filter-item-multi-select {
        // padding-bottom: 25px;
        padding-top: 18px;
        padding-bottom: 0px;
        .el-select{
          margin-top: 0px;
          width: 298px;
          height: 45px;
        }
        .agent-groups.el-select {
          margin-top: 7px;
        }
        .devices.el-select {
          margin-top: 7px;
        }
        .el-select__tags {
          max-width: 168px;
          // height: 28px;
          .el-tag.el-tag--info {
            max-width: 108px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          // .el-input--suffix input.el-input__inner {
          //   height: 38px !important;
          // }
          .el-select__input {
            height: 20px;
            position: relative;
            top: 9px;
            left: 2px;
          }
        }
      }
      .mutiple-select-section.agent-queues {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agent-ids {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agent-groups {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.devices {
        .el-tag__close {
            display: none;
          }
      }
      
      input.el-input__inner {
        // border: 1px solid var(--top-menu-panel-filters-dropdown-border-color) !important;
        border: 1px solid #D2D8DC !important;
        border-radius: 5px;
        padding-left: 10px;
        height: 40px !important;
        color: var(--nav-top-primary-color);
        // background-color: var(--nav-top-menu-panel-background-color);
        background-color: #FFF;
        font-size: 14px;
      }

      .max-topics {
        padding-left: 30px;
      
        .el-input-number.is-controls-right .el-input__inner {
          padding-left: 28px;
          padding-right: 28px;
        }
        .vue__time-picker.time-picker {
          width: 90px !important;
          user-select: none;
        }
      }
      .wy-filter-item-integer {
        .el-input-number--mini {
          width: 106px;
          line-height: 26px;
          position: relative;
          top: 5px;
        }
        .el-dropdown-menu__item {
          line-height: 30px;
          position: relative;
          bottom: 9px;
          i{
            transform: scale(0.9) !important;
            top: 6px;
            right: 5px;
            position: relative;
          }
        }
      }
      .el-input-number__decrease {
        border: 0px !important;
        border-radius: 0 0 4px;
        position: relative;
        left: 15px !important;
        top: 28px !important;
        background-color: transparent;
        .el-icon-arrow-down::before {
          content: var(--header-icon-grey-decrease);
        }
      }
      .el-input-number__increase {
        border: 0px !important;
        border-radius: 0 0 4px;
        position: relative;
        left: 61px !important;
        top: 28px !important;
        background-color: transparent;
        .el-icon-arrow-up::before {
          content: var(--header-icon-grey-increase);
        }
      }
    }
  }

  .date-filter-picker-panel {
    top: 17px !important;
    left: -330px !important;
    
    .popper__arrow {
      display: none;
    }
    .el-date-table td.prev-month {
      color: #B3B3B3;
      background-color: #F5F5F5;
    }
    .el-date-table th {
      background-color: #EBF4FD;
      color: #4C7CAE;
    }
    .el-date-table td.start-date span,
    .el-date-table td.end-date span {
      background-color: var(--site-font-primary-color) !important;
    }
    .el-date-table td.in-range div {
      background-color: #004A87 !important;
      color: white !important;
    }
  }
  .el-select .el-input .el-select__caret {
    transform: rotateZ(0deg);
  }
  .el-select__caret.el-input__icon.el-icon-arrow-up:before {
    content: var(--header-drop-down-arrow-down);
  }
  .el-select .el-input .el-select__caret.is-reverse:before {
    content: var(--header-drop-down-arrow-up);
  }
}

.wy-header-menu-directions-panel.wy-header-menu-panel{
  height: 188px !important;
  width: 364px !important;
  // left: 923px !important;
}
.wy-header-menu-panel.wy-header-menu-directions-panel {
  // width: 200px;
  // width: fit-content;
  width: min-content;
  border-radius: 0px;
  width: 641px;
  // left: 922px!important;
  // left: var(--site-top-menu-platforms-panel-left) !important;

  margin: 64px 0 0px 0 !important;
  overflow-x: hidden;
  overflow-y: hidden;
  // @media (max-width: 1854px) {
  @media (max-width: 1440px) {
    .wy-header-menu-panel {
      left: 299px !important;
    }
  }
  .cancel-btn{
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    width: 612px;
    height: 36px;
    text-align: start;
    padding: 20px 0px 0px 25px;
    position: relative;
    font-size: 14px;
    // top: 59px;
    right: -3px;
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
  }
  .menu-panel {
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    border-radius: 0px 0px 5px 7px;
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    padding: 0;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-left: -1px;
    height: 188px !important;
    width: 364px !important;
    position: relative;
    // left: 2px;
    left: 0px;
    // border-top: 1px solid #C9D3DA;
  }
  .wy-white-button.direction-apply {
    width: 104px;
    height: 30px;
    border-radius: 10px;
    border: 1px white solid;
    left: calc(100% - 761px);
    top: 343px;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    padding-top: 6px;
    font-size: 14px;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }

  .panel-column {
    display: inline-grid;
    // width: 36%;
    padding: 0px 15px 0px 0px;
    width: 97.5%;
    height: 320px;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
    .panel-header{
      font-size: 17px;
      font-weight: 500;
      padding-bottom: 15px; 
      color: var(--site-font-primary-color);        
    }
    .isBlue{
      color: #214586;
    }
    // .title-header {
    //   font-weight: 600;
    //   font-size: 14px;
    //   color: #214586;
    //   padding-bottom: 2px;
    // }
    .title-header {
      font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
      font-size: var(--top-menu-panel-global-filter-header-text-font-size);
      color: var(--top-menu-panel-global-filter-header-text-color);
      padding: 15px 20px 0px 20px;
      line-height: 5px;
      top: 8px;
      left: 2px;
      position: relative;
    }
  }
  .el-checkbox-group {
    height: 251px;
  }
  div.el-checkbox-group label.el-checkbox {
    display: block;
    line-height: 36px;
    color: #F4F6F8;
    position: relative;
    left: -9px;
    height: 33px;
    padding-left: 14px !important;
    margin-top: 20px;
    padding-bottom: -3px;
    .el-checkbox__label {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: var(--top-menu-panel-global-filter-checkbox-text-color);
    }
    span.el-checkbox__inner {
      border-radius: 0px;
      background-color: var(--top-menu-panel-global-filter-checkbox-button-background-color);
      color: var(--top-menu-panel-global-filter-checkbox-button-check-color);
      border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-border-color) !important;
      top: 0px !important;
      width: 12px !important;
      height: 12px !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      // background-color: #020E14;
      background-color: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
      border-radius: 0px;
    }
    .el-checkbox__inner::after {
      border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-check-color);
      border-left: 0;
      border-top: 0;
      width: 2px !important;
    }
    span.el-checkbox__inner:hover {
      -webkit-box-shadow: unset;
      box-shadow: unset;
    }
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--top-menu-panel-global-filter-checkbox-text-checked-color);
  }
  .el-checkbox-group .is-disabled {
    opacity: 1;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #214586;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #FFF;
  }

  ul {
    padding-left: 0px;
    height: 270px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .direction-name.selected {
    border: 0.5px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 3px;
    width: 243px;
    .checkedIcon{
      background-image: url('../../../assets/icons/icon_white_check.svg');
      background-repeat: no-repeat;
      background-size: 15px 15px;
      background-position-x: 3px;
      background-position-y: 8px;
      width: 20px;
      height: 30px;
      vertical-align: middle;
      float: right;
    }
  }
  .direction-name {
    color: #F4F6F8;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 0.5px transparent solid;
    list-style: none;
    position: relative;
    right: 5px;
    top: 18px;
    height: 24px;
    margin: 0px 18px 8px 18px;
    margin-bottom: 16px;
    width: 276px;
    line-height: 30px;
    padding: 0px 0px 12px 15px;
  }
  .direction-name:focus, .brand-name:hover {
    background-color: rgba(229, 234, 242, 0.09);
    .checkedIcon{
      color: #EBF4FD;
    }
    color: #F4F6F8;
  }
}
.wy-header-menu-direction.selected {
  background: var(--nav-top-background-color-selected) 0% 0% no-repeat padding-box !important;
  position: relative;
  z-index: 9999;
}

.wy-header-menu-direction {
  &:hover{
    // background: rgba(229, 234, 242, 0.09) !important;
  }
  width: fit-content;
  height: 74px !important;
  .wy-header-manu-dropdown{
    margin: 0px 0px 0px 0px !important;
    padding: 14px 0px 0 0px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    height: 74px;
    width: 150px !important;
    // top: -14px !important;

    .el-dropdown-title {      
      white-space: nowrap;

    }
    
  }
  .wy-header-manu-dropdown.el-dropdown:hover {
    background-color: none !important;
  }
}
.direction-dropdown {
  margin-top: 2px !important;
  .el-select-dropdown__item.selected {
    color: #006fe7;
    font-weight: unset;
    background-color: #e8f1ff !important;
  }
}
</style>